import { PortalBgType, PortalTextType } from '@nx-frontend/shared/types/portal-colors';
import { TailwindCommonPalette } from '@nx-frontend/shared/types/tailwind-palette';
import { ThemeButtonColorConfig } from '@nx-frontend/shared/types/theme';

export const defaultButtonTheme: ThemeButtonColorConfig = {
  bg: {
    default: PortalBgType.SECONDARY,
    hover: PortalBgType.SECONDARY_HOVER,
  },
  text: {
    default: PortalTextType.SECONDARY,
  },
};

export const disabledButtonTheme: ThemeButtonColorConfig = {
  bg: {
    default: [TailwindCommonPalette.GRAY_300],
    hover: [TailwindCommonPalette.GRAY_300],
  },
  text: {
    default: [TailwindCommonPalette.WHITE],
  },
};

export const disabledStrokeButtonTheme: ThemeButtonColorConfig = {
  ...disabledButtonTheme,
  text: {
    default: [TailwindCommonPalette.GRAY_300],
  },
};

export const buttonThemeCyan: ThemeButtonColorConfig = {
  bg: {
    default: [TailwindCommonPalette.CYAN_900],
    hover: [TailwindCommonPalette.CYAN_800],
  },
  text: {
    default: [TailwindCommonPalette.WHITE],
  },
};
